angular.module('qkr').directive('scrollBottom', () => ({
        link(scope, element, attr) {
            const $id = $('#' + attr.scrollBottom);
            $(element).on('click', () => {
                $id.scrollTop($id[0].scrollHeight);
            });
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/scroll_bottom.js